import React from 'react';
import styled from 'styled-components';
import { SchoolOutlined, CodeOutlined, CloudOutlined, ApiOutlined } from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
`;

const Heading = styled.h1`
  text-align: center;
  margin-bottom: 40px;
`;

const DocSection = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  h2 {
    margin-top: 0;
  }

  a {
    text-decoration: none;
    color: #007bff;
    font-weight: bold;
  }
`;

const IconWrapper = styled.div`
  margin-right: 20px;
  color: #007bff;
`;

const SectionContent = styled.div`
  flex: 1;
`;

const Docs = () => {
  return (
    <PageContainer>
      <Heading>DevOps Buddy Documentation</Heading>
      <p style={{textAlign: 'center', marginBottom: '40px'}}>Welcome to the official documentation. Find guides, tutorials, and API references to help you get the most out of our platform.</p>
      
      <DocSection>
        <IconWrapper><SchoolOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <h2>Getting Started</h2>
          <p>New to DevOps Buddy? Our getting started guide will walk you through setting up your account and your first project.</p>
          <a href="#">Read the guide &rarr;</a>
        </SectionContent>
      </DocSection>

      <DocSection>
        <IconWrapper><CodeOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <h2>CI/CD Pipelines</h2>
          <p>Learn how to configure, manage, and optimize your continuous integration and deployment workflows.</p>
          <a href="#">Explore CI/CD Docs &rarr;</a>
        </SectionContent>
      </DocSection>

      <DocSection>
        <IconWrapper><CloudOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <h2>Cloud Monitoring</h2>
          <p>Understand how to monitor your cloud resources, manage costs, and ensure optimal performance.</p>
          <a href="#">View Monitoring Guides &rarr;</a>
        </SectionContent>
      </DocSection>

      <DocSection>
        <IconWrapper><ApiOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <h2>API Reference</h2>
          <p>Integrate with DevOps Buddy programmatically using our REST API. Find detailed information on all available endpoints.</p>
          <a href="#">Consult the API Reference &rarr;</a>
        </SectionContent>
      </DocSection>
    </PageContainer>
  );
};

export default Docs;
